import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSurveys } from 'contexts/surveys'
import {
    Tutorial,
    CardList, CardListCell, containerProps,
    LoadingContainer
} from './s'
import Survey from './survey'
import { Ghost } from 'components/button'
import Loader from 'components/loader'

const Surveys = () => {
    const {
        surveys,
        intersecter,
        paging = {},
        fetchSurveys,
        hasFetched,
        autoFetch,
        loading,
        fetching
    } = useSurveys()

    if(hasFetched && !surveys.length) {
        return <Tutorial which="surveys" />
    }

    return (
        <CardList {...containerProps}>
            <CardList.Header>
                <CardListCell $cell="name">
                    <FormattedMessage
                        id="noun_name"
                        defaultMessage="Name" />
                </CardListCell>
                <CardListCell $cell="status">
                    <FormattedMessage
                        id="noun_status"
                        defaultMessage="Status" />
                </CardListCell>
            </CardList.Header>
            {surveys.map((survey, surveyIndex) => {
                const lastSurvey = surveyIndex + 1 === surveys.length

                return (
                    <Survey
                        survey={survey}
                        {...(lastSurvey ? { ref: intersecter } : null)}
                        key={survey.id} />
                )
            })}
            <CardList.Loader
                loading={fetching}
                count={2}
                items={[
                    {
                        type: 'avatarAndFullName',
                        cell: 'symbol meta',
                        size: 40,
                        showSecondLine: true
                    },
                    {
                        type: 'status',
                        cell: 'status'
                    }
                ]} />
            {!!paging?.hasNextPage && (
                <LoadingContainer>
                    {(!loading && !autoFetch) && (
                        <Ghost
                            className="constructive"
                            onClick={fetchSurveys}>
                            <FormattedMessage
                                id="action_load_more"
                                defaultMessage="Load more…"
                            />
                        </Ghost>
                    )}
                    {!!loading && <Loader />}
                </LoadingContainer>
            )}
        </CardList>
    )
}

export default Surveys